var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonV2',{attrs:{"data-cy":"drop-what-are-drops","label":_vm.$t('drops.what_are_drops'),"size":"medium","testId":"btn-whatAreDrops","version":"secondary"},on:{"onClick":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }